import { Slide, ToastContainer } from "react-toastify";
import { media } from "src/styles/mixins";
import styled from "styled-components";

export const StyledToastContainer = styled(ToastContainer).attrs({
  autoClose: 15000,
  closeButton: false,
  transition: Slide,
})`
  ${media.down("MOBILE")`
    left: unset;
    top: 1em;
  `}

  max-width: 360px;
  margin-top: var(--nav-height);
  && {
    width: 90%;
  }

  .Toastify__toast {
    padding: 16px 18px;
    margin-bottom: 18px;

    box-sizing: border-box;
    border-radius: 8px;
  }

  .Toastify__toast-body {
    display: flex;
    flex-direction: row;
    margin: 0 0;
    padding: 0 0;

    p,
    h2 {
      font-family: "sofia-pro";
      font-weight: ${({ theme }) => theme.fonts.weights.normal};
    }
  }

  .Toastify__toast--error {
    border: 2px solid ${({ theme }) => theme.colors.toasts.error.border};
    background-color: ${({ theme }) => theme.colors.toasts.error.background};
  }

  .Toastify__toast--warning {
    border: 2px solid ${({ theme }) => theme.colors.toasts.warning.border};
    background-color: ${({ theme }) => theme.colors.toasts.warning.background};
  }

  .Toastify__toast--success {
    border: 2px solid ${({ theme }) => theme.colors.toasts.success.border};
    background-color: ${({ theme }) => theme.colors.toasts.success.background};
  }

  .toastIcon {
    align-self: flex-start;
    margin-top: 2px;
  }
`;

export const ToastContentWrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ToastTextWrapper = styled.div`
  padding-left: 18px;
  padding-right: 21px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const ToastTitleHeader = styled.h2`
  font-size: ${({ theme }) => theme.fonts.sizes.xxs};
  line-height: ${({ theme }) => theme.fonts.lineHeights.xxs};
  color: ${({ theme }) => theme.colors.toasts.title};
`;

export const ToastTextParagraph = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.xxxs};
  line-height: ${({ theme }) => theme.fonts.lineHeights.xxxs};
  color: ${({ theme }) => theme.colors.toasts.text};
`;
